import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { withTranslate } from 'shared/hocs/withTranslate';
import EllipseOkIcon from 'shared/components/Icons/EllipseOkIcon';

// eslint-disable-next-line css-modules/no-unused-class
import s from './SuggestionResultForm.css';

class SuggestionResultForm extends React.Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
  };

  render() {
    const { t } = this.props;
    return (
      <div className={s.containerCenter}>
        <EllipseOkIcon />
        <div className={s.containerResultTitle}>
          {t('Дякуємо! Ми направили заявку нашим партнерам.!')}
        </div>
        <div className={s.containerResultText}>
          {t('Очікуйте, будь ласка, з Вами зв’яжуться протягом робочого дня.')}
        </div>
      </div>
    );
  }
}

export default withStyles(s)(withTranslate(SuggestionResultForm));



// WEBPACK FOOTER //
// ./src/shared/components/SuggestForDefaultAd/SuggestionResultForm/SuggestionResultForm.js